import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useCarromm } from "../../context/carromm";
import Dimension from "../../pages/dimension/Dimension";
import {
  setOutputUrl,
  resetSkuId,
  setStatus,
  setZoomModelVisibility,
} from "../../redux/slices/carrommSlice";
import ZoomableImageModal from "../zoomableImageModal";
const SideTabs = ({ contents }) => {
  const {
    previewImages,
    dimension,
    output_url,
    sku_id,
    activeUrl
  } = useSelector((state) => state.carromm);
  console.log(activeUrl,"activeUrl")
  const carrom = useCarromm();
  const dispatch = useDispatch();
  const selectTabHandler = (tab) => {
    if (tab?.id) console.log("clicked tab", carrom.tabs);
    let [activeTab] = carrom.tabs
      .filter((item) => item.active === true)
      .map((i) => i?.id);
    if (
      activeTab &&
      activeTab === "show-result" &&
      output_url !== "" &&
      sku_id
    ) {
      dispatch(setOutputUrl(""));
      dispatch(resetSkuId());
      dispatch(setStatus("restart"));
    }
    carrom.setTabs(carrom.tabs.map((t) => ({ ...t, active: t.id === tab.id })));
  };

  useEffect(() => {
    carrom.setTabs(
      carrom.tabs.map((t, i) => ({
        ...t,
        content: contents[i],
        isDisable: i !== 0,
      }))
    );
  }, [contents?.length, carrom?.tabs?.length]);

  useEffect(() => {
    if (carrom.tabs && carrom.tabs.length > 0 && carrom.tabs[0].content) {
      carrom.setTabs(
        carrom.tabs.map((t, i) => ({
          ...t,
          isDisable: !previewImages?.length ? true : false,
        }))
      );
    }
  }, [previewImages, carrom?.tabs?.length]);

  const logout = () => {
    localStorage.removeItem("user");
    window.location.reload();
  };

  const handleModalToggle = () => {
    dispatch(setZoomModelVisibility(false));
  };

  return (
    <>
      {dimension !== "" ? (
        <>
          {/* Tabs menus  */}
          <div className="md:flex">
            <ul
              className="nav nav-pills nav-pills "
              id="pills-tab"
              role="tablist"
            >
              <li className="logo-item">
                <img src="./assets/image/logo.png" alt="logo" />
              </li>
              {carrom.tabs.map((tab, index) => (
                <li
                  key={tab?.id || index}
                  className={`nav-item ${tab?.isDisable ? "disabled" : ""}`}
                  role="presentation"
                  onClick={() => selectTabHandler(tab)}
                >
                  <center
                    className={`nav-link fw-semibold ${
                      tab?.name !== "Result" ? "position-relative" : ""
                    }${tab?.active ? " active" : ""}`}
                    data-bs-toggle="pill"
                    data-bs-target={`#pills-${tab?.id}`}
                    role="tab"
                    aria-controls={`pills-${tab?.id}`}
                    aria-selected={tab?.active}
                  >
                    {tab?.icon && <img src={tab?.icon} alt={tab?.icon} />}
                    <span>
                      {tab?.id === "home"
                        ? `${dimension} ${tab?.title}`
                        : tab?.title}
                    </span>
                  </center>
                </li>
              ))}
              <li className="nav-item" onClick={() => logout()}>
                <center className={`nav-link fw-semibold position-relative`}>
                  Abmeldung
                </center>
              </li>
            </ul>
            {/* Tabs Contents */}
            <div id="pills-tabContent" className="tab-content w-100">
              {carrom.tabs.map((tab, index) => (
                <div
                  key={`contents-${tab?.id || index}`}
                  className={`tab-pane fade${
                    tab?.active ? " show active" : ""
                  }`}
                  id={`pills-${tab?.id}`}
                  role="tabpanel"
                  aria-labelledby={`pills-${tab?.id}-tab`}
                >
                  {tab.content && <tab.content />}
                </div>
              ))}
            </div>
          </div>
        </>
      ) : (
        <Dimension />
      )}

      <ZoomableImageModal
        handleModalToggle={handleModalToggle}
      />
    </>
  );
};

export default SideTabs;
